import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import { Link, Redirect } from 'react-router-dom';
import ModalCompanyDialog from './ModalCompanyDialog';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { connect } from 'react-redux';
import { badgesType } from '../../constants/constants';

const refModal = React.createRef();

function RemovePynsImportedCompany(props) {
  const [uidCompany, setUidCompany] = useState('');
  const [company, setCompany] = useState(null);
  const [country, setCountry] = useState('');
  const [type, setType] = useState('');
  const [pynsImported, setPynsImported] = useState([]);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [showProcessText, setShowProcessText] = useState(false);
  const [validTypeBadge, setValidTypeBadge] = useState(false);
  const [validPynsImported, setValidPynsImported] = useState(false);
  const [validCountry, setValidCountry] = useState(false);
  const [validCompany, setValidCompany] = useState(false);
  const { firestore, companies, auth } = props;

  useEffect(() => M.AutoInit(), []);

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const search = (searchTerm) => {
    filterCompanies(country, searchTerm);
  };

  const updateCountry = (country) => {
    setCountry(country);
    filterCompanies(country, '');
  };

  const filterCompanies = (country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  };

  const getPynsImportedByCompany = () => {
    if (company) {
      firestore
        .collection('pyns_imported')
        .where('uidCompany', '==', uidCompany)
        .where('country', '==', country)
        .get()
        .then((querySnapshot) => {
          const pynsImported = [];
          querySnapshot.forEach((doc) => {
            pynsImported.push({ id: doc.id, ...doc.data() });
          });
          setPynsImported(pynsImported);
        })
        .catch((e) => {
          console.log('Error get pynsImported', e.message());
        });
    } else {
      console.log('NO VALID');
    }
  };

  const validFields = () => {
    const validPyns = pynsImported.length > 0;
    const validCountry = country != null && country.length > 0;
    const validTypeBadge = type != null && type.length > 0;
    const validCompany = company != null;
    setValidPynsImported(validPyns);
    setValidCountry(validCountry);
    setValidTypeBadge(validTypeBadge);
    setValidCompany(validCompany);

    return validPyns && validCountry && validTypeBadge && validCompany;
  };

  const removePyns = async () => {
    if (validFields() && !showProcessText) {
      try {
        if (pynsImported && pynsImported.length > 0) {
          const promises = [];
          let query = firestore.collection('pyns_imported');
          setShowProcessText(true);
          pynsImported.forEach((pi) => {
            promises.push(query.doc(pi.id).delete());
          });
          await Promise.all(promises);
          setShowProcessText(false);
          setPynsImported([]);
        }
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  const renderTypeSelect = () => {
    const types = [];
    for (const key in badgesType) types.push(badgesType[key]);
    return (
      <div className="row">
        <div className="input-field col s12">
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Select a type</option>
            {types.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <label>Type</label>
        </div>
      </div>
    );
  };

  const renderSelectCountry = () => {
    return (
      <div className="row">
        <div className="input-field col s12">
          <select
            className="icons"
            value={country}
            onChange={(e) => {
              updateCountry(e.target.value);
            }}>
            <option value="" disabled>
              Select your Country
            </option>
            <option data-icon="images/ca.svg" value="CA">
              Canada
            </option>
            <option data-icon="images/us.svg" value="US">
              United States
            </option>
            <option data-icon="images/bo.svg" value="BO">
              Bolivia
            </option>
          </select>
          <label>Country</label>
        </div>
      </div>
    );
  };
  
  if (!auth.uid) {
    return <Redirect to="/signin" />;
  }
  
  return (
    <div className="container">
      <div className="title-section">Import Pyns by company</div>
      {showProcessText ? <h3>Processing...</h3> : <div />}
      <div className="row">
        <div className="col s6 card-content">
          {renderTypeSelect()}
          {renderSelectCountry()}
          <div className="row">
            <div className="input-field">
              <div className="col s6">
                <label htmlFor="company_uid">Company UID</label>
                {company ? <p>{company.companyName}</p> : <div />}
                <input id="company_uid" type="text" name="uidCompany" value={uidCompany} onChange={(e) => setUidCompany(e.target.value)} />
              </div>
              <div className="col s6">
                <Link to="#" onClick={() => openCompanyDialog()}>
                  Select company
                </Link>
              </div>
            </div>
          </div>
          <div>
            {!validTypeBadge ? <p className="red-text"> Select Type</p> : <div />}
            {!validCountry ? <p className="red-text">Select Country</p> : <div />}
            {!validCompany ? <p className="red-text">Select Company</p> : <div />}
            {!validPynsImported ? <p className="red-text">There are no pyns</p> : <div />}
            <button className="waves-effect waves-light btn btn-large" onClick={removePyns}>
              Remove Pyns Imported
            </button>
          </div>
        </div>

        <div className="col s6 card-content">
          <div>
            <button className="waves-effect waves-light btn btn-large" onClick={getPynsImportedByCompany}>
              Get Pyns Imported
            </button>
            <p>Pyns Imported</p>
          </div>
          <div className="placeSearchContainer">
            {pynsImported && pynsImported.length > 0 ? (
              pynsImported.map((p) => {
                return (
                  <div className="card" key={p.id}>
                    <div className="card-content">
                      <p>Id: {p.id}</p>
                      <p>State: {p.state}</p>
                      <p>Country: {p.country}</p>
                      <p>address: {p.address}</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
      <ModalCompanyDialog refModal={refModal} search={search} currentCompanies={currentCompanies} setUidCompany={setUidCompany} setCompany={setCompany} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]), connect(mapStateToProps))(RemovePynsImportedCompany);
